module.exports = __webpack_public_path__ + "static/media/crowdplat-header.ebe4573c.png";